export default __webpack_public_path__ + "static/media/timer.9d574338.mp3";